import PriceSchemePricingTab from './PriceSchemePricingTab';
export default PriceSchemePricingTab;
